import { combineEpics } from 'redux-observable'

import flowEpics from './Flow/epics'
import incidentOverviewEpics from './IncidentOverview/epics'
import listEpics from './List/epics'

export default combineEpics(flowEpics, listEpics, incidentOverviewEpics)
